import { ReactComponent as Close } from '@public/images/svg/close.svg'
import { ReactComponent as WarnGray } from '@public/images/svg/warn-gray.svg'
import { ReactComponent as Warn } from '@public/images/svg/warn.svg'

export interface SvgType {
	name: string
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>
}

export const svg: SvgType[] = [
	{ name: 'close', icon: Close },
	{ name: 'warn-gray', icon: WarnGray },
	{ name: 'warn', icon: Warn },
]
